import axios from "axios";
import urls from "./urls";

function get(id) {
  return axios.get(urls.api + "company/" + id, {
    headers: {
      "X-Auth-Token": localStorage.token,
      "X-Password": localStorage.pass,
    },
  });
}

const functions = {
  get,
};

export default functions;
